
import {Component, Vue, Watch} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import UserInfoService from '@/service/modules/UserInfoService'
import UserInfo from '@/model/modules/UserInfo'
import UserEditor from '@/views/module-user-manage/user-editor.vue'
import UserChargeEditor from '@/views/module-user-manage/user-charge-editor.vue'
import UserOrderObserver from '@/views/module-user-manage/user-order-observer.vue'

@Component({
  components: {UserOrderObserver, UserChargeEditor, UserEditor}
})
export default class ModuleUserManage extends Vue {
  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '用户ID', value: 'id'},
    {text: '姓名', value: 'name'},
    {text: '昵称', value: 'nickName'},
    {text: '手机号码', value: 'phone'},
    {text: '账号', value: 'userName'},
    {text: '电子邮件', value: 'email'},
    {text: '账户余额', value: 'totalPrice', sortable: false},
    {text: '押金', value: 'deposit', sortable: false},
    {text: '操作', value: 'action', sortable: false}
  ]

  queryLikeResult: BasePageableInfo<UserInfo> = new BasePageableInfo<UserInfo>()
  queryType: string = 'userName'
  queryWord: string = ''
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  mounted() {
    this.refreshAllData()
  }

  @Watch('pageSize')
  refreshAllData() {
    this.listLoadingState = true
    const searchExample = {}
    searchExample[this.queryType] = this.queryWord
    UserInfoService.list(searchExample, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<UserInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  newItem() {
    this.editItem(new UserInfo())
  }

  editItem(item: UserInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  charge(item: UserInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userChargeEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  showOrderObserver(item: UserInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userOrderObserver.showObserver(item)
  }
}
